import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// Models
import IQuizEvent from 'models/QuizEvent';
// Async
import { createQuizEvent, deleteQuizEvent, getQuizEvents, triggerQuizEvent, updateQuizEvent } from './quizEventAsync';

interface IState {
  quizEvents: IQuizEvent[] | null;
};

const initialState:IState = {
  quizEvents: null,
};

const slice = createSlice({
  name: 'quizEvent',
  initialState,
  reducers: {
    setInitialField: <IStateKey extends keyof IState>(state:IState, action:PayloadAction<IStateKey>) => {
      state[action.payload] = initialState[action.payload];
    }
  },
  extraReducers: (builder) => {
    // Get quiz events
    builder.addCase(getQuizEvents.pending, (state) => {
      state.quizEvents = null;
    });
    builder.addCase(getQuizEvents.fulfilled, (state, action:PayloadAction<IQuizEvent[]>) => {
      state.quizEvents = action.payload;
    });
    // Create quiz event
    builder.addCase(createQuizEvent.fulfilled, (state, action:PayloadAction<IQuizEvent>) => {
      if (state.quizEvents) {
        state.quizEvents = [...state.quizEvents, action.payload];
      }
    })
    // Update quiz event
    builder.addCase(updateQuizEvent.fulfilled, (state, action:PayloadAction<IQuizEvent>) => {
      if (state.quizEvents) {
        state.quizEvents = state.quizEvents.map(quizEvent => {
          if (quizEvent._id === action.payload._id) {
            return action.payload;
          }
          return quizEvent;
        });
      }
    });
    // Delete quiz event
    builder.addCase(deleteQuizEvent.fulfilled, (state, action) => {
      if (state.quizEvents) {
        const quizEventId = action.meta.arg;
        state.quizEvents = state.quizEvents.filter(quizEvent => quizEvent._id !== quizEventId);
      }
    });
    // Trigger quiz event
    builder.addCase(triggerQuizEvent.fulfilled, (state, action:PayloadAction<IQuizEvent>) => {
      if (state.quizEvents) {
        state.quizEvents = state.quizEvents.map(quizEvent => {
          if (quizEvent._id === action.payload._id) {
            return action.payload;
          }
          return quizEvent;
        });
      }
    });
  }
});

export const { setInitialField } = slice.actions;

export default slice.reducer;
